function DoForumsBadge()
{
	var objXmlHttp = new XMLHttpRequest();
	objXmlHttp.open('GET', '/mr-utils/userinfo.php', true);
	objXmlHttp.onreadystatechange = function()
	{
		if (objXmlHttp.status !== 200) return;

		var objItem = null;
		var strResponseText = objXmlHttp.responseText;
		if (!strResponseText) return;

		objItem = JSON.parse(strResponseText);
		var elem = document.getElementById('ForumsBadge');
		var elemMobile = document.getElementById('ForumsBadgeMobile');

		intBadgeCount = objItem.alertcount + objItem.convcount;

		if (!intBadgeCount) return;

		elem.classList.add('badgeContainer');
		elem.setAttribute('data-badge', intBadgeCount);
		elemMobile.classList.add('badgeContainer');
		elemMobile.setAttribute('data-badge', intBadgeCount);
	}

	objXmlHttp.send(null);
}

if (forum_logged_in) DoForumsBadge();
